export class InvoiceTaxModel {

    id: number;
    uid: string;
    taxId: number;
    taxImport: number;
    type: string;
    name: string;
}
